module.exports = __webpack_public_path__ + "static/media/deletePermanently.1d5dc07a.svg";